
if (!window.SwymCallbacks) { 
  window.SwymCallbacks = []; 
}

window.SwymCallbacks.push(function() {
  _swat.fetchWrtEventTypeET(function(products) {
    debug() && console.log(products);

    // no items
    if (products.length === 0) {
      noProducts(true)
    }
    // render the saved items
    else {
      noProducts(false)
      renderProducts(products)
    }
  }, _swat.EventTypes.addToWishlist)

  // listen for the remove event and check if there are still items, if not, show the text
  _swat.evtLayer.addEventListener('sw:removedfromwishlist', (e) => {
    _swat.fetchWrtEventTypeET(function(unique) {
      if (unique.length === 0) {
        noProducts(true)
      }
    })
  })
});

function renderProducts(products) {
  if (!products) return

  // use map instead of forEach because async/await won't work
  const promises = products.map(async (product) => {
    await fetch(`${product.du}?view=product-card-wishlist`)
      .then(response => response.text())
      .then(responseText => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productHTML = parsedHTML.getElementById('product-card').querySelector('.product-card-wrapper');
        productHTML.dataset.removeId = JSON.stringify(product);

        // update the variant id, so the right one gets added
        productHTML.querySelector('input[name="id"]').value = product.epi;
        productHTML.querySelector('[data-wishlist-variant]').textContent = product.vi;
        
        if (productHTML) {
        // appending the slide will automatically trigger the class and init the product card swiper
          document.querySelector('.wishlist-content').append(productHTML);
        }
      })
      .catch(error => {
        debug() && console.log(error);
      })
      .finally(() => {
        // add event listener for the remove buttons
        document.querySelectorAll('[data-wishlist-remove]').forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const productCard = button.closest('.product-card-wrapper');
            const productObj = JSON.parse(productCard.dataset.removeId);

            // remove the item
            _swat.removeFromWishList(productObj, function() {
              // fade out the product card
              productCard.classList.add('fade');
              setTimeout(() => {
                productCard.remove()
              }, 250);
            });
          })
        });
      });
  });
}

function noProducts(show) {
  const loader = document.querySelector('.wishlist-content [data-loader]');
  loader.classList.add('hidden');

  const noItemsTextEl = document.querySelector('.wishlist-content__no-items');
  show ? noItemsTextEl.classList.remove('hidden') : noItemsTextEl.classList.add('hidden');
}